export function Spinner({ size = 18 }: { size?: number }) {
  return <span className="spinner" style={{ width: size, height: size }} role="status" aria-label="Loading" />;
}

export function PageSpinner() {
  return (
    <div className="page-spinner">
      <Spinner size={22} />
    </div>
  );
}
